/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * キャンセル料を修正するリクエスト
 * @export
 * @interface UpdateBillingCancellationFeeRequest
 */
export interface UpdateBillingCancellationFeeRequest {
    /**
     * 実績支払方法
     * @type {string}
     * @memberof UpdateBillingCancellationFeeRequest
     */
    paymentMethod: UpdateBillingCancellationFeeRequestPaymentMethodEnum | null;
    /**
     * Cancellation fee
     * @type {number}
     * @memberof UpdateBillingCancellationFeeRequest
     */
    cancellationFee: number;
    /**
     * Note
     * @type {string}
     * @memberof UpdateBillingCancellationFeeRequest
     */
    note?: string;
}


/**
 * @export
 */
export const UpdateBillingCancellationFeeRequestPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type UpdateBillingCancellationFeeRequestPaymentMethodEnum = typeof UpdateBillingCancellationFeeRequestPaymentMethodEnum[keyof typeof UpdateBillingCancellationFeeRequestPaymentMethodEnum];


/**
 * Check if a given object implements the UpdateBillingCancellationFeeRequest interface.
 */
export function instanceOfUpdateBillingCancellationFeeRequest(value: object): value is UpdateBillingCancellationFeeRequest {
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('cancellationFee' in value) || value['cancellationFee'] === undefined) return false;
    return true;
}

export function UpdateBillingCancellationFeeRequestFromJSON(json: any): UpdateBillingCancellationFeeRequest {
    return UpdateBillingCancellationFeeRequestFromJSONTyped(json, false);
}

export function UpdateBillingCancellationFeeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingCancellationFeeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethod': json['payment_method'],
        'cancellationFee': json['cancellation_fee'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function UpdateBillingCancellationFeeRequestToJSON(json: any): UpdateBillingCancellationFeeRequest {
    return UpdateBillingCancellationFeeRequestToJSONTyped(json, false);
}

export function UpdateBillingCancellationFeeRequestToJSONTyped(value?: UpdateBillingCancellationFeeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method': value['paymentMethod'],
        'cancellation_fee': value['cancellationFee'],
        'note': value['note'],
    };
}

